// Component: StatusBadge.jsx
// Purpose: Shared order-status badge — maps an order status to a DS Badge variant
//          and renders it sentence-cased. Single source of truth for the
//          status→variant map + titleCase helper (previously duplicated and
//          divergent across OrdersTable and OrderDetailDrawer).

import React from 'react';
import { Badge } from '../ds';

//--> Sentence-case helper (first char upper, rest lower)
const titleCase = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s);

//--> Status → DS Badge variant map
const STATUS_VARIANT = {
  FILLED:    'profit',
  PENDING:   'warn',
  SUBMITTED: 'info',
  OPEN:      'info',
  REJECTED:  'loss',
  CANCELLED: 'neutral',
  //! #10494-23 lane C — terminalised (dead) order, same neutral/grey treatment
  //  as CANCELLED. Explicit entry (not a fallback) so the vocabulary is
  //  self-documenting.
  EXPIRED:   'neutral',
};

//! 10509-6/E13/D31/Q3 — a REJECTED take-profit row held for the exchange price band (still
//  awaiting release, `held_take_profit` returns it every poll) shows this display-only override
//  instead of the raw "Rejected" badge. `display_state` is derived server-side
//  (`_resolve_current_edge` / OMS order read) — never re-derived here. Absent/other values fall
//  through to the ordinary status→variant map unchanged.
const StatusBadge = ({ status, display_state, size = 'sm' }) => {
  if (display_state === 'waiting_price_band') {
    return (
      <Badge variant="warn" size={size}>
        Waiting – price band
      </Badge>
    );
  }
  return (
    <Badge variant={STATUS_VARIANT[status] || 'neutral'} size={size}>
      {titleCase(status)}
    </Badge>
  );
};

export default StatusBadge;
